import React, {useEffect, useState} from 'react';
import '../Options.css';

import Radio from '../../../App/Common/Inputs/Radio/Radio';



const SingleChoice = ({ options, questionId, setAnswers, answers, allAnswers  }) => {
    const [selectedOption, setSelectedOption] = useState([])

    const checkAnswer = (id) => {
        setSelectedOption(id)
        setAnswers(id)
    }
    console.log(answers)

    useEffect(() => {
        setSelectedOption(answers)
        setAnswers(answers)
    }, [])

    useEffect(() => {
        setSelectedOption(allAnswers === null ? answers : allAnswers[questionId])
        setAnswers(allAnswers === null ? answers : allAnswers[questionId] )
    }, [questionId])

    return (
        <fieldset>
            {options.map((option, index) => (
                <div className='multiChoice__option' key={option.order_number}>
                   <Radio option={option} onChangeAction={() => checkAnswer([option.id])}  name={questionId} test isChecked={selectedOption === option.id || (selectedOption && selectedOption.length > 0 && selectedOption[0] === option.id)} />
                </div>
            ))
            }
        </fieldset>

    )
}
export default SingleChoice